/** Hoe het portaal geopend is. `standalone` betekent: als geinstalleerde app,
 *  niet in een browsertab.
 *
 *  Dit is het enige dat de backend niet zelf kan zien. Om wat voor apparaat het
 *  gaat leest de backend uit de user-agent-header van het verzoek — hier dus
 *  geen platformdetectie: iPadOS meldt zich als Mac, en zulke regels raken stil
 *  verkeerd zonder dat iemand het merkt. */
export type DisplayMode = 'standalone' | 'browser'

/** iOS Safari kent geen display-mode: daar is `navigator.standalone` het enige
 *  signaal dat de app vanaf het beginscherm is gestart. */
export function isIosStandalone(): boolean {
  if (typeof window === 'undefined') return false
  return (
    'standalone' in window.navigator &&
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}

/** Android en desktop melden het via display-mode. Alle drie deze modi
 *  betekenen "als app geopend" — alleen op `standalone` matchen mist de
 *  manifesten die fullscreen of minimal-ui vragen. */
export function isDisplayModeStandalone(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return ['standalone', 'fullscreen', 'minimal-ui'].some(
    (mode) => window.matchMedia(`(display-mode: ${mode})`).matches
  )
}

export function isStandalone(): boolean {
  return isIosStandalone() || isDisplayModeStandalone()
}

export function displayMode(): DisplayMode {
  return isStandalone() ? 'standalone' : 'browser'
}
